import { Droppable } from "@hello-pangea/dnd";
import MenuSection from "./MenuSection";

const MenuSections = (props) => {
  const sections = props.sections || [];

  return (
    <Droppable droppableId="sections" type="droppableItem">
      {(provided) => (
        <div
          className={`menu-sections ${!props.editMode && "view-mode"}`}
          ref={provided.innerRef}
        >
          {sections.map((section, index) => (
            <MenuSection
              key={section.id}
              item={section}
              index={index}
              editMode={props.editMode}
              handlerFunctions={{
                onSectionDelete: props.onSectionDelete,
                onUpdateSection: props.onUpdateSection,
                onItemUpdate: props.onItemUpdate,
                onItemDetete: props.onItemDetete,
                onItemReorder: props.handleItemReorder,
              }}
              onMoveEnd={(newList) => props.handleSectionReorder(newList)}
            />
          ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  );
};

export default MenuSections;
